export default "__VITE_ASSET__WZEVF2ie__"